import { render, staticRenderFns } from "./KnowledgeBasePanel.vue?vue&type=template&id=2d8694ed&scoped=true"
import script from "./KnowledgeBasePanel.vue?vue&type=script&lang=js"
export * from "./KnowledgeBasePanel.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBasePanel.vue?vue&type=style&index=0&id=2d8694ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8694ed",
  null
  
)

export default component.exports